import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=457b839e&scoped=true&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"
import style0 from "./RealEstate.vue?vue&type=style&index=0&id=457b839e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b839e",
  null
  
)

export default component.exports